export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/environments/environment.prod.ts